import styled from 'styled-components';
import { colors } from 'ui/theme';
import { SegmentedControl, SEGMENTED_CONTROL_SIZES } from 'ui/segmentedControl';

import { DQBSearchVariant } from './types';
import { useCombinatorSelectOptions, useCombinatorControlOptions } from './hooks';
import { CombinatorSelectProps } from '../types';
import { QueryBuilderSelect } from '../Selects';

type DQBSearchVariantProps = {
  variant: DQBSearchVariant;
};

export const DATA_TEST = {
  control: 'combinator-control',
  select: 'combinator-select',
};

// Overwrite color specific styling for segmented control core component
const StyledSegmentedControl = styled(SegmentedControl)`
  div[aria-checked='true']:not([aria-disabled='true']) {
    &[data-test='segmented-control-option-Or']:hover {
      svg[data-temporary-fix] path {
        fill: ${colors.cyan50};
      }
    }
    &[data-test='segmented-control-option-Not']:hover {
      svg[data-temporary-fix] path {
        fill: ${colors.salmon50};
      }
    }
  }
  div[aria-checked='false']:not([aria-disabled='true']) {
    &:hover {
      svg[data-temporary-fix] path {
        fill: ${colors.iconPrimary};
      }
    }
  }
   /* Set disabled coloring */
   div[aria-disabled='true'] {
      svg {
      border-color: ${colors.iconDisabled} !important;
    }
    
    svg path {
      fill: ${colors.iconDisabled} !important;
    }
    
    svg path[stroke] {
      stroke: ${colors.iconDisabled} !important;
    }
   }
`;

export const CombinatorSelect = ({
  value,
  onChange,
  variant,
  ...props
}: CombinatorSelectProps & DQBSearchVariantProps) => {
  const controlOptions = useCombinatorControlOptions(variant);
  const selectOptions = useCombinatorSelectOptions();
  return variant !== DQBSearchVariant.Requirement ? (
    <StyledSegmentedControl
      {...props}
      data-test={DATA_TEST.control}
      options={controlOptions}
      onSelect={onChange}
      value={value?.toString()}
      size={SEGMENTED_CONTROL_SIZES.MEDIUM}
    />
  ) : (
    <QueryBuilderSelect
      {...props}
      data-test={DATA_TEST.select}
      options={selectOptions}
      onChange={onChange}
      value={value}
    />
  );
};
